module.exports = __webpack_public_path__ + "static/img/grandfather-background.cc25688.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/grandfather-background.jpg
// module id = 1Od+
// module chunks = 1